/////////////////////////////////////////////////////////////
import { Link } from 'react-router-dom';
import { ArrowRight } from '../../icons';

interface MenuOptionProps {
	title: string;
	path: string;
	onClickOption: () => void;
}

export const DailyTaskOption: React.FC<MenuOptionProps> = ({
	title,
	path,
}: MenuOptionProps) => {
	/*********************
	// #region Template
	**********************/
	return (
		<Link to={path}>
			<div className="flex rounded-2xl items-center bg-daily-reward-gradient p-3 option-menu-setting shadow-lg shadow-black/25">
				<img
					className="drop-shadow-lg"
					src={process.env.VITE_DAILY_REWARD_BOX_IMAGE}
					width={105}
					height={105}
				/>
				<div className="flex flex-col w-full ml-3 gap-1">
					<p className="text-base font-semibold">{title}</p>
				</div>
				<div className="p-3">
					<ArrowRight fillcolor="white" />
				</div>
			</div>
		</Link>
	);
};
